import { OverallStats } from "./OverallStats";

export default OverallStats;
